export default __webpack_public_path__ + "static/media/25-TapestryOfTuscany.fbb2e388.jpeg";